import '../App.sass';

interface Properties {
}

export default function BillingPanel(properties: Properties) {
    return <><div>
    </div>
    </>;
}